// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';
import ResourceLinkSchema from './resource-link-schema';

const schema = {
  $id: '/tdg-feedback-list-schema',
  type: 'object',
  required: ['id', 'creatorId', 'companyId', 'organisationId', 'youthVisitorsCount'],
  nullable: true,
  properties: {
    id: {
      type: 'integer',
    },
    links: {
      type: 'array',
      nullable: true,
      items: { ...ResourceLinkSchema },
    },
    creatorId: {
      type: 'integer',
    },
    creatorName: {
      type: 'string',
      nullable: true,
    },
    created: {
      type: 'string',
      format: 'date-time',
    },
    modifierId: {
      type: 'integer',
      nullable: true,
    },
    modifierName: {
      type: 'string',
      nullable: true,
    },
    modified: {
      type: 'string',
      format: 'date-time',
      nullable: true,
    },
    companyId: {
      type: 'integer',
    },
    organisationId: {
      type: 'integer',
    },
    companyName: {
      type: 'string',
      nullable: true,
    },
    organisationName: {
      type: 'string',
      nullable: true,
    },
    eventRating: {
      enum: [
        1,
        2,
        3,
      ],
    },
    reparticipationRating: {
      enum: [
        1,
        2,
        3,
      ],
    },
    youthVisitorsCount: {
      type: 'integer',
    },
    adultVisitorsCount: {
      type: 'integer',
      nullable: true,
    },
    remark: {
      type: 'string',
      nullable: true,
    },
  },
} as IJSONSchema;

export default schema;
